import React from 'react';
import './index.scss';
import { CnButton, CnIcon, CnTooltip } from '@cainiaofe/cn-ui';

const NavBar = (props) => {
  const { title, logo, buttons = [], actions = [], onClickButton, onClickAction } = props;
  return (
    <div className="chatai-ui-navbar">
      <div className="main">
        {logo && <img className="logo" src={logo} alt={title} />}
        <div className="inner">
          <h2 className="title">{title}</h2>
        </div>
      </div>
      <div className="right">
        {buttons.map((item) => (
          <CnButton
            className="tool"
            size="small"
            type="normal"
            onClick={() => {
              onClickButton(item);
            }}
          >
            {item.icon ? <CnIcon type={item.icon} /> : null}
            {item.label}
          </CnButton>
        ))}
        {actions.map((item) => (
          <div className="icon">
            <CnTooltip
              align="bl"
              popupStyle={{
                whiteSpace: 'no-wrap',
              }}
              trigger={
                <CnIcon
                  size={16}
                  type={item.icon}
                  onClick={() => {
                    onClickAction(item);
                  }}
                />
              }
            >
              {item.label}
            </CnTooltip>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NavBar;
